<nav class="navbar navbar-expand-lg navbar-light bg-dark p-0">
    <div class="container">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item"><a class="nav-link" routerLink="/price-robot/products">Products</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/price-robot/competitors">Competitors</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/price-robot/rules">Rules</a></li>
            </ul>
        </div>
    </div>
</nav>
